import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Wallet, Clock } from "lucide-react";
import GiftCredit from "./GiftCredit";

export default function CreditExpiryCard() {
  const [c, setC] = useState(null);
  const load = useCallback(() => api.get("/me/credits").then((r) => setC(r.data)).catch(() => setC(false)), []);
  useEffect(() => { load(); }, [load]);
  if (!c || !(c.balance > 0)) return null;
  const soon = c.days_left != null && c.days_left <= 14;
  return (
    <section className={`mb-8 rounded-2xl border p-4 flex items-center gap-4 flex-wrap ${soon ? "border-amber-400/40 bg-amber-500/10" : "border-slate-800 bg-[#0B0D12]"}`} data-testid="credit-expiry-card">
      <span className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${soon ? "bg-amber-400/20" : "bg-emerald-500/15"}`}><Wallet className={`w-5 h-5 ${soon ? "text-amber-300" : "text-emerald-300"}`} /></span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold">Ride credit <span className="font-mono text-emerald-300" data-testid="credit-balance">${c.balance.toFixed(2)}</span></p>
        {c.next_expiry && <p className={`text-xs inline-flex items-center gap-1 mt-0.5 ${soon ? "text-amber-200" : "text-slate-400"}`} data-testid="credit-next-expiry"><Clock className="w-3 h-3" />${Number(c.next_expiry_amount).toFixed(2)} expires {new Date(c.next_expiry).toLocaleDateString()} ({c.days_left} day{c.days_left === 1 ? "" : "s"} left)</p>}
      </div>
      {c.balance >= 5 && <GiftCredit balance={c.balance} onDone={load} />}
      <Link to="/browse" className="text-xs font-semibold text-cyan-300 hover:underline shrink-0" data-testid="credit-use-link">Use it →</Link>
    </section>
  );
}
